module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.account && Object.keys(_vm.account).length > 0) ? _c('shared-product-provide', {
    attrs: {
      "product": _vm.product,
      "fromModule": _vm.fromModule,
      "toModule": _vm.toModule
    }
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "c-box"
  }, [_c('loader', {
    attrs: {
      "loading": _vm.sending,
      "label": _vm.getCountVariations()
    }
  }), _vm._v(" "), _c('header', {
    staticClass: "c-box__heading",
    class: {
      disabledHeader: _vm.product.status === 'cannotSend'
    },
    on: {
      "click": function($event) {
        return _vm.toggleProductInfo()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('i', {
    staticClass: "u-floatRight icon",
    class: _vm.toggleIconClass()
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show && !_vm.everyVariationWithErrorOrSent),
      expression: "show && !everyVariationWithErrorOrSent"
    }],
    staticClass: "c-box__body"
  }, [_c('div', {
    staticClass: "c-box__inner"
  }, [(_vm.product) ? _c('panel', {
    attrs: {
      "title": "Informações gerais do produto"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('button', {
    staticClass: "hint hint--left btn btn--info",
    class: {
      'is-loading': _vm.addingImage
    },
    attrs: {
      "disabled": _vm.addingImage,
      "data-label": "Adicionar uma imagem em uma ou mais variações"
    },
    on: {
      "click": function($event) {
        _vm.addingImage = true
      }
    }
  }, [_vm._v("\n              Adicionar Imagem\n            ")]), _vm._v(" "), _c('modal-add-image', {
    attrs: {
      "visible": _vm.addingImage,
      "variations": _vm.product.variations,
      "callback": _vm.uploadedImage,
      "module": _vm.moduleUploadImageModal
    },
    on: {
      "close": function (close) { return _vm.addingImage = close; }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "slot": "product",
      "label": "Título",
      "columns": 12,
      "error": _vm.getError('title', _vm.product.productId),
      "required": true
    },
    slot: "product"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.title),
      expression: "product.title"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": _vm.disabledInput('title')
    },
    domProps: {
      "value": (_vm.product.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.maxTitleLengthDI !== null) ? _c('small', {
    staticClass: "form-help",
    class: _vm.titleLength
  }, [_vm._v(_vm._s(_vm.getTitleLengthLabel()))]) : _vm._e()]), _vm._v(" "), _c('form-group', {
    attrs: {
      "slot": "product",
      "label": "Descrição",
      "columns": 12,
      "error": _vm.getError('description', _vm.product.productId),
      "required": true
    },
    slot: "product"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.description),
      expression: "product.description"
    }],
    staticClass: "form-textarea",
    attrs: {
      "rows": "8",
      "disabled": _vm.disabledInput('description')
    },
    domProps: {
      "value": (_vm.product.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.maxDescriptionLengthDI !== null) ? _c('small', {
    staticClass: "form-help",
    class: _vm.descriptionLength
  }, [_vm._v(_vm._s(_vm.getDescriptionLengthLabel()))]) : _vm._e()]), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Categoria",
      "columns": 6,
      "required": true,
      "disabled": _vm.disabledInputs(),
      "error": _vm.getError('selectedCategory', _vm.product.productId)
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loadingCategories
    }
  }), _vm._v(" "), (!_vm.loadingCategories) ? _vm._l((_vm.visibleLevels), function(_, idx) {
    return _c('select', {
      key: idx,
      staticClass: "form-select",
      staticStyle: {
        "margin-bottom": "4px"
      },
      attrs: {
        "disabled": _vm.disabledInputs()
      },
      domProps: {
        "value": _vm.getSelectedCategoryId(idx)
      },
      on: {
        "change": function($event) {
          return _vm.onCategoryChangeById(idx, $event.target.value)
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": ""
      },
      domProps: {
        "value": null
      }
    }, [_vm._v("Selecione o nível " + _vm._s(idx + 1))]), _vm._v(" "), _vm._l((_vm.categoryOptions(idx)), function(cat) {
      return _c('option', {
        key: cat.id,
        domProps: {
          "value": cat.id
        }
      }, [_vm._v("\n                    " + _vm._s(cat.name) + "\n                  ")])
    })], 2)
  }) : _vm._e()], 2), _vm._v(" "), (_vm.selectedCategory) ? _c('form-group', {
    attrs: {
      "label": "Marca",
      "columns": 6,
      "required": true,
      "disabled": _vm.disabledInputs(),
      "error": _vm.getError('selectedBrand', _vm.product.productId)
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loadingBrands
    }
  }), _vm._v(" "), (_vm.brandOptions.length) ? _c('div', {
    staticClass: "select-wrapper"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedBrand),
      expression: "selectedBrand"
    }],
    staticClass: "form-select",
    attrs: {
      "disabled": _vm.loadingBrands || _vm.disabledInputs()
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedBrand = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione uma marca")]), _vm._v(" "), _vm._l((_vm.brandOptions), function(brand) {
    return _c('option', {
      key: brand.id,
      domProps: {
        "value": brand
      }
    }, [_vm._v("\n                    " + _vm._s(brand.name) + "\n                  ")])
  })], 2)]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedBrand),
      expression: "selectedBrand"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": _vm.loadingBrands || _vm.disabledInputs(),
      "placeholder": "Digite a marca"
    },
    domProps: {
      "value": (_vm.selectedBrand)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedBrand = $event.target.value
      }
    }
  })], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.selectedCategory) ? _c('panel', {
    attrs: {
      "title": "Atributos"
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loadingAttributes
    }
  }), _vm._v(" "), (!_vm.selectedCategory && !_vm.loadingAttributes) ? _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('p', {
    staticClass: "placeholder-msg"
  }, [_vm._v("Selecione a categoria para exibir os atributos.")])])]) : (_vm.attributes.length) ? _c('div', {
    staticClass: "l-row"
  }, _vm._l((_vm.viewProductAttributes), function(attribute) {
    return _c('form-group', {
      key: attribute.id,
      attrs: {
        "label": attribute.name,
        "required": attribute.isRequired,
        "columns": 6,
        "error": _vm.getError(String(attribute.id), _vm.product.productId)
      }
    }, [(attribute.isMultipleSelection || attribute.isCustomizable) ? _c('multiselect', {
      attrs: {
        "options": attribute.values || [],
        "track-by": "id",
        "label": "name",
        "multiple": attribute.isMultipleSelection || attribute.isCustomizable,
        "close-on-select": !attribute.isMultipleSelection,
        "clear-on-select": false,
        "hide-selected": true,
        "taggable": attribute.isCustomizable,
        "placeholder": _vm.getAttributePlaceholder(attribute),
        "disabled": _vm.disabledInputs()
      },
      on: {
        "tag": function (val) { return _vm.addCustomTagProduct(attribute, val); }
      },
      model: {
        value: (_vm.localAttrValues[attribute.id]),
        callback: function($$v) {
          _vm.$set(_vm.localAttrValues, attribute.id, $$v)
        },
        expression: "localAttrValues[attribute.id]"
      }
    }) : (attribute.values && attribute.values.length) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.localAttrValues[attribute.id]),
        expression: "localAttrValues[attribute.id]"
      }],
      staticClass: "form-select",
      attrs: {
        "disabled": _vm.disabledInputs()
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.localAttrValues, attribute.id, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": ""
      },
      domProps: {
        "value": null
      }
    }, [_vm._v(_vm._s(_vm.getAttributePlaceholder(attribute)))]), _vm._v(" "), _vm._l((attribute.values), function(value) {
      return _c('option', {
        key: value.id,
        domProps: {
          "value": value
        }
      }, [_vm._v("\n                  " + _vm._s(value.name) + "\n                ")])
    })], 2) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.localAttrValues[attribute.id]),
        expression: "localAttrValues[attribute.id]"
      }],
      staticClass: "form-input",
      attrs: {
        "type": "text",
        "placeholder": _vm.getAttributePlaceholder(attribute),
        "disabled": _vm.disabledInputs()
      },
      domProps: {
        "value": (_vm.localAttrValues[attribute.id])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.localAttrValues, attribute.id, $event.target.value)
        }
      }
    })], 1)
  }), 1) : (_vm.selectedCategory && !_vm.loadingAttributes) ? _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('p', {
    staticClass: "placeholder-msg"
  }, [_vm._v("Esta categoria não possui atributos configuráveis.")])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }, [_c('span', [_vm._v("Informações das variações do produto")])]), _vm._v(" "), _c('div', {
    staticClass: "l-row vertical-flex"
  }, _vm._l((_vm.product.variations), function(variation) {
    return _c('div', {
      key: variation.sku || variation.id,
      staticClass: "l-col-12@md"
    }, [_c('MarketplaceProvideVariationShein', {
      attrs: {
        "variation": variation,
        "from-module": _vm.fromModule,
        "to-module": _vm.toModule,
        "variation-attributes": _vm.viewVariationAttributes,
        "loading-variation-attributes": _vm.loadingAttributes
      }
    })], 1)
  }), 0)], 1)])], 1) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm.product.title))])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-701e4d31","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/shein/provide/Product.vue
// module id = 3281
// module chunks = 0